import { createAsyncThunk } from '@reduxjs/toolkit'

import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../application/application-slice'
// controller code

export type AddCategoryArg = {
  name: string
  description: string
}

export type UpdateCategoryArg = {
  description: string
  categoryId: string
  name: string
}

export type DeleteCategoryArg = {
  categoryId: string
}

export type GetCategoryByNameArg = {
  categoryName: string
}

export const AddCategoryAsync = createAsyncThunk<any, AddCategoryArg, any>(
  'composer/categoryController/add/category',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('categoryController/add/category'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const UpdateCategoryAsync = createAsyncThunk<
  any,
  UpdateCategoryArg,
  any
>(
  'composer/categoryController/update/category',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('categoryController/update/category'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const DeleteCategoryAsync = createAsyncThunk<
  any,
  DeleteCategoryArg,
  any
>(
  'composer/categoryController/delete/category',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('categoryController/delete/category'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const GetCategoryByNameAsync = createAsyncThunk<
  any,
  GetCategoryByNameArg,
  any
>(
  'composer/categoryController/get/category/by/name',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('categoryController/get/category/by/name'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
